import dayjs from "dayjs";

export const getSummaryPanelHeader = (
  isDeparture: boolean,
  location: string,
  date: string,
  parsable = false
) =>
  `${isDeparture ? "Outbound" : "Return"} to ${location} ${
    parsable ? ":" : ""
  } on ${dayjs(date).format("ddd, MMM D")}`;

export const CHANGE_FLIGHT_TEXT = "Change Flight";
export const CHANGE_OUTBOUND_FLIGHT_TEXT = "Change outbound flight";
export const CHANGE_RETURN_FLIGHT_TEXT = "Change return flight";
